





















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class UserDropDownField extends Vue {
  @Prop() value!: object;
  @Prop() userList: object[] = [];
  @Prop() placeholder: string = null;
  @Prop() required = false;
  @Prop() valueId: number = null;

  keyword = null;
  loading = false;
  validasi = [v => !!v || "*Isian Harus Diisi"];

  @Watch("value")
  valueChanged(val) {
    this.$emit("input", val);
  }
}
